import React from 'react';
import { monthName } from '../../../../shared/constants';
import { Durations } from '../../../../shared/constants';
import DateSelectorContent from '../../DateSelector/DateSelectorContent';
import TimePickerContent from '../../TimePicker/TimePickerContent';
import SlotPicker from '../../SlotPicker/SlotPicker';
import Textarea from '../../Textarea/Textarea';
import './DateTImeStep3.css';

const DateTimeStep3 = (props) => {
   return(
    <div className="date-time-step-three">
        <div className="slot-info">
          <p className="slot-info-first-p">Choose some dates and times that suit you.<span> A Minimum of {props.candidateLength?props.candidateLength:0} {props.candidateLength === 1?"slot":"slots"} required for {props.candidateLength?props.candidateLength:0} {props.candidateLength === 1?"candidate":"candidates"}.</span></p>
          <p className="slot-info-second-p">By selecting more available times you have a greater chance of scheduling a time with the candidate.</p>
        </div>
        <div className="date-selector">
          <DateSelectorContent           
            calendarOpen={true}
            monthYear={monthName[props.date.getMonth()] + ' ' + props.date.getFullYear()}
            handlePreviousMonth={props.handlePreviousMonth}
            handleNextMonth={props.handleNextMonth}
            handlePreviousWeek={props.handlePreviousWeek}
            handleNextWeek={props.handleNextWeek}
            getWeekDays={props.getWeekDays}
            isSameDay={props.isSameDay}
            current={props.current}
            handleSelect={props.handleSelect}
            today={props.today}
            leftPosition={props.leftPosition}
            isSlotSelector = {true}
            selectedDates={props.selectedSlots}
            isClient={props.isClient}
            calendarFirstDate={props.calendarFirstDate}
          />
        </div>
        <div className={props.slotsDisabled? "ampm disable-slots" : "ampm"}>
          <div className="Left-border"></div>
          <div className="time-box">
              <div className={props.isAmPm ==="am"?"am active-period":"am"} onClick={() =>props.handleAMPM("am")}>AM</div>
              <div className={props.isAmPm ==="pm"?"pm active-period":"pm"} onClick={() =>props.handleAMPM("pm")}>PM</div>
          </div>
          <div className="right-border"></div>
        </div>
        <div className={props.slotsDisabled? "timeslots disable-slots" : "timeslots"}>
          <SlotPicker
           duration={props.interviewDuration}
           timeSelect={props.timeSelect}
           selectedSlots={props.selectedSlots}
           currentSelectedDate={props.current? props.current: new Date()}
           isAmPm={props.isAmPm}
           overlappingSlots={props.overlappingSlots}
           />
        </div>
        {props.slotsInvalid? <div className="time-slot-validation">
          <p>You have not selected enough time slots, please select more time slots in order to schedule all candidates.</p>
        </div>: null}
        {props.disableNotesSection?null:<div className="notes">
          <p>Would you like to send a note to your recruiter?</p>
          <Textarea
            name="textarea-message" 
            placeholder="eg: Can we touch base on these times?"
            value={props.interviewMessage}
            onChange={(e) => props.handleInterviewMessage(e)}
            >
          </Textarea>
        </div>}       

    </div>
  );
}

export default DateTimeStep3;


// WEBPACK FOOTER //
// ./src/components/UI/StepperContent/DateTImeStep3/DateTImeStep3.js